export default "__VITE_ASSET__CuCRQV_Z__"